// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `PaginationLink {
    height: 30px;
}

.flex-center {
    display: flex;
    align-items: center;
    justify-content: start;
}

.flex-center .input-select{
    margin-top:-16px;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 2px;
    padding-left:8px;
    color: #333;
    width: 1.5cm;
    margin-right: 10px;
}

.pagination-right {
    float: right;
}

.pagination-link {
    color: var(--pagination-color);
    height: 30px;
}

.active-page {
    color: white !important;
    background-color: grey !important;
    height: 30px;
}

.inactive-page {
    color: grey !important;
    height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/componentStyles/paginationBar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB","sourcesContent":["PaginationLink {\n    height: 30px;\n}\n\n.flex-center {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n}\n\n.flex-center .input-select{\n    margin-top:-16px;\n    height: 30px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 2px;\n    padding-left:8px;\n    color: #333;\n    width: 1.5cm;\n    margin-right: 10px;\n}\n\n.pagination-right {\n    float: right;\n}\n\n.pagination-link {\n    color: var(--pagination-color);\n    height: 30px;\n}\n\n.active-page {\n    color: white !important;\n    background-color: grey !important;\n    height: 30px;\n}\n\n.inactive-page {\n    color: grey !important;\n    height: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
